(function(){
  document.addEventListener('DOMContentLoaded', function(){
    const STORAGE_KEY = 'ch_active_type';
    const overlay = document.getElementById('ch-mobile-menu');
    if (!overlay) return;

    const toggles = {
      bicycle: overlay.querySelector('.ch-mobile-btn--bicycle'),
      motorcycle: overlay.querySelector('.ch-mobile-btn--motorcycle')
    };
    const menus = {
      bicycle: overlay.querySelector('.ch-mobile-nav--bicycle'),
      motorcycle: overlay.querySelector('.ch-mobile-nav--motorcycle')
    };

    const closeBtn = overlay.querySelector('.ch-mobile-menu__close');

    function showMenu(type){
      Object.values(toggles).forEach(b => b.classList.remove('is-active'));
      Object.values(menus).forEach(m => m.classList.remove('is-active'));
      toggles[type]?.classList.add('is-active');
      menus[type]?.classList.add('is-active');
      localStorage.setItem(STORAGE_KEY, type);
    }

window.openOverlay = function(){
  overlay.classList.add('is-active');
  const saved = localStorage.getItem(STORAGE_KEY) || 'bicycle';
  showMenu(saved);
};
window.closeOverlay = function(){
  overlay.classList.remove('is-active');
};

    Object.entries(toggles).forEach(([type,btn])=>{
      btn.addEventListener('click', ()=> showMenu(type));
    });
    closeBtn.addEventListener('click', closeOverlay);

    // hook to your hamburger button
    const burger = document.querySelector('.menu-drawer-button');
    if (burger){
      burger.addEventListener('click', e=>{
        e.preventDefault();
        openOverlay();
      });
    }

    // Disable Shopify's built-in mobile drawer
document.addEventListener('click', function(e){
  const btn = e.target.closest('.menu-drawer-button, [aria-controls="MenuDrawer"]');
  if (btn){
    e.preventDefault();
    e.stopPropagation();
    // Instead, open our custom menu
    const overlay = document.getElementById('ch-mobile-menu');
    if (overlay && typeof openOverlay === 'function') {
      openOverlay();
    }
  }
}, true);

    console.log('✅ ch-mobile-menu.js loaded');
  });
})();
